import React, { FC } from 'react';
import { Dialog, DialogContent, DialogActions, Button } from '@lesmills-international/components';

interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  message: string;
  confirmText: string;
  cancelText?: string;
  isLoading?: boolean;
}

const ConfirmationDialog: FC<ConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  message,
  confirmText,
  cancelText = 'Cancel',
  isLoading = false,
}) => (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(0, 0, 0, 0.2)', // Very transparent - users can see workout content
        },
      }}
      PaperProps={{
        style: {
          width: 'clamp(300px, 90vw, 520px)',
          maxWidth: '90vw',
          margin: '16px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)', // Add shadow for dialog visibility
        }
      }}
    >
      <DialogContent>
        <div
          style={{
            padding: 'clamp(12px, 3vw, 20px) clamp(16px, 4vw, 24px) clamp(8px, 2vw, 12px)',
            textAlign: 'left', // 🎨 FIX: Left-aligned text for better readability
          }}
        >
          <span style={{ 
            fontSize: 'clamp(14px, 4vw, 18px)', 
            lineHeight: '1.5',
            wordBreak: 'break-word',
          }}>
            {message}
          </span>
        </div>
      </DialogContent>
      <DialogActions>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            padding: 'clamp(8px, 2vw, 16px) clamp(16px, 4vw, 24px)',
            gap: 'clamp(8px, 3vw, 16px)',
          }}
        >
          <Button
            variant="text"
            style={{ 
              padding: 'clamp(6px, 2vw, 10px) clamp(12px, 3vw, 20px)',
              minWidth: 'clamp(60px, 18vw, 100px)',
              fontSize: 'clamp(14px, 3.5vw, 16px)',
              // 🔧 FIX: Proper disabled button styling
              cursor: isLoading ? 'not-allowed' : 'pointer',
              opacity: isLoading ? 0.5 : 1,
              pointerEvents: isLoading ? 'none' : 'auto', // Prevent all mouse interactions when disabled
            }}
            onClick={onClose}
            disabled={isLoading}
          >
            {cancelText}
          </Button>
          <Button
            style={{ 
              borderRadius: '100px',
              minWidth: 'clamp(60px, 18vw, 100px)',
              fontSize: 'clamp(14px, 3.5vw, 16px)',
              padding: 'clamp(6px, 2vw, 10px) clamp(12px, 3vw, 20px)',
              // 🔧 FIX: Proper disabled button styling when loading
              cursor: isLoading ? 'not-allowed' : 'pointer',
              opacity: isLoading ? 0.6 : 1,
              pointerEvents: isLoading ? 'none' : 'auto', // Prevent all mouse interactions when loading
            }}
            onClick={onConfirm}
            loading={isLoading}
          >
            {confirmText}
          </Button>
        </div>
      </DialogActions>
    </Dialog>
);

export default ConfirmationDialog;
